// Gestion de l'affichage temporaire du pop-up d'annonce.

// Fenêtre d'affichage du pop-up "outil d'aide à la prescription" :
// du 18 juin au 1er juillet inclus.
export const PRESCRIPTION_ANNOUNCEMENT_START = new Date("2026-06-18T00:00:00");
export const PRESCRIPTION_ANNOUNCEMENT_END = new Date("2026-07-01T23:59:59");

export const isPrescriptionAnnouncementActive = (
  now: Date = new Date()
): boolean => {
  return (
    now >= PRESCRIPTION_ANNOUNCEMENT_START &&
    now <= PRESCRIPTION_ANNOUNCEMENT_END
  );
};
